import http from "./httpService";
import { API_URL } from "../config";
import { buildDownloadUrl } from "../utils/downloadUtils";

export const callActionApiAsync = async (
  apiFunc,
  setData,
  handleError,
  setLoader
) => {
  if (setLoader) setLoader(true);
  try {
    await apiFunc()
      .then(async (response) => {
        if (response && setData && typeof setData === "function") {
          if (setData.constructor.name === "AsyncFunction")
            await setData(response.data);
          else setData(response.data);
        }
      })
      .catch((err) => {
        var error = "";
        if (err.response) {
          if (err.response.data) {
            error = err.response.data.error;
            console.log("error-response: ", err.response.data.error);
          } else {
            error = err.response;
            console.log("error-response: ", err.response);
          }
        } else if (err.request) {
          error = err.request;
          console.log("error-request: ", err.request);
        } else {
          error = err;
          console.log("error-error: ", err);
        }

        if (handleError) {
          console.log("handleError: -> ", error);
          handleError(error);
        }
      })
      .then(() => {
        if (setLoader) setLoader(false);
      });
  } catch (e) {
    console.log("error: ", e.message);
  }
};

export const callApiAsync = async (apiFunc, setData, setLoader) => {
  await callActionApiAsync(
    apiFunc,
    setData,
    (error) => {
      //   if (typeof error === "string") NotificationManager.error(error);
    }, //, (data) => dispatch(setLoader(data))
    (data) => {
      if (setLoader) setLoader(data);
    }
  );
};

export const getAuthorityByUser = (userId, options = {}) => {
  const params = new URLSearchParams();
  if (options.legacy) params.set("legacy", "1");
  const queryString = params.toString();
  return http.get(
    `${API_URL}/getAuthorityByUser/${userId}${queryString ? `?${queryString}` : ""}`
  );
};
export const getCallTimeFrameState = () =>
  http.get(`${API_URL}/getTimeFrameState/`);
/** Config de versionado del módulo de riesgos y oportunidades (entityType: 'risk' | 'opportunity'). Otros módulos tendrán sus propios endpoints. */
export const getRiskAndOpportunityVersionConfig = (entityType = "risk") =>
  http.get(`${API_URL}/getRiskAndOpportunityVersionConfig/${entityType}`);

export const getCallProcess = (includeHidden = false) => {
  const query = includeHidden ? "?includeHidden=true" : "";
  return http.get(`${API_URL}/getProcess${query}`);
};

export const getCallRiskType = () => http.get(`${API_URL}/getRiskType/1`);
export const postUpdateRisksAndOpportunities = (userId) =>
  http.post(`${API_URL}/updateRisksAndOpportunities`, userId);

export const postUpdateRiskTreatment = (data) =>
  http.post(`${API_URL}/updateRiskTreatment`, data);

export const postUpdateOpportunityTreatment = (data) =>
  http.post(`${API_URL}/updateOpportunityTreatment`, data);
export const postUpdateOpportunityValuation = (data) =>
  http.post(`${API_URL}/updateOpportunityValuation`, data);

export const postCreateOpportunity = (data) =>
  http.post(`${API_URL}/createOpportunity`, data);

export const postCreateDofa = (data) =>
  http.post(`${API_URL}/createDofa`, data);
export const postUpdateDofa = (data) =>
  http.post(`${API_URL}/updateDofa`, data);

export const postUpdateField = (data) =>
  http.post(`${API_URL}/updatefield`, data);
export const postUpdatePaiGoal = (data) =>
  http.post(`${API_URL}/updatePaiGoal`, data);
export const postUpdateActions = (data) =>
  http.post(`${API_URL}/updateActions`, data);
export const postSavePaiObservation = (data) =>
  http.post(`${API_URL}/savePaiObservation`, data);
export const postSaveEmployeeComment = (data) =>
  http.post(`${API_URL}/saveEmployeeComment`, data);
export const postAddAnswers = (data) =>
  http.post(`${API_URL}/addAnswers`, data);
export const postCreateUpdateReport = (data) =>
  http.post(`${API_URL}/createUpdateReport`, data);

export const postCreateRisk = (data) =>
  http.post(`${API_URL}/createRisk`, data);
export const postUpdateRiskDetail = (data) =>
  http.post(`${API_URL}/updateRiskDetail`, data);
export const postUpdateRiskValuation = (data) =>
  http.post(`${API_URL}/updateRiskValuation`, data);
export const postUpdateStatusRisk = (data) =>
  http.post(`${API_URL}/updateStatusRisk`, data);

export const postUpdateEvidence = (data) =>
  http.post(`${API_URL}/updateEvidence`, data);

export const postUpdateOpportunityDetail = (data) =>
  http.post(`${API_URL}/updateOpportunityDetail`, data);

export const postUpdateTimeFrameState = () =>
  http.post(`${API_URL}/updateTimeFrameState`);
export const postCreateDashboard = (data) =>
  http.post(`${API_URL}/createDashboard`, data);

export const postUpdateReport360Observations = (data) =>
  http.post(`${API_URL}/updateReport360Observations`, data);

export const getCallDofaReport = (userId, year, month) =>
  http.get(`${API_URL}/getDofaReport/${userId}/${year}/${month}`);
export const getCallJsonSettingVersion = () =>
  http.get(
    `${API_URL}/getJsonSettingVersion/RISK_OPPORTUNITY_MANAGEMENT_VERSION`
  );
export const getSettingById = (settingId) =>
  http.get(`${API_URL}/getSettingById/${settingId}`);

export const getCallDofaByUser = (userId, month, year, processId, state) =>
  http.get(
    `${API_URL}/getDofaByUser/${userId}/${month}/${year}/${processId}/${state}`
  );

export const getCallPaiObservationData = (id) =>
  http.get(`${API_URL}/getPaiObservationData/${id}`);

export const getCallPaiData = (userId) =>
  http.get(`${API_URL}/getPaiData/${userId}`);

export const getCallAutoEvaluation = (userId) =>
  http.get(`${API_URL}/getAutoEvaluation/${userId}`);

export const getCallPairSurvey = (userId) =>
  http.get(`${API_URL}/getPairSurvey/${userId}`);

export const getCallColabSurvey = (userId, year) =>
  http.get(`${API_URL}/getColabSurvey/${userId}/${year}`);

export const getCallManagerSurvey = (userId, year) =>
  http.get(`${API_URL}/getManagerSurvey/${userId}/${year}`);

export const getCallSurvey = (surveyId) =>
  http.get(`${API_URL}/getSurvey/${surveyId}`);

export const getCallActivitiesByCompetency = (userId) =>
  http.get(`${API_URL}/getActivitiesByCompetency/${userId}`);

export const getCallPositionList = () => http.get(`${API_URL}/getPositionList`);

export const getCallPowerBiById = (menuItemId) =>
  http.get(`${API_URL}/getPowerBiById/${menuItemId}`);

export const getCallPowerBiProcessList = (id) =>
  http.get(`${API_URL}/getPowerBiProcessList/${id}`);

export const getCallRisksList = (userId, year, month, processId) =>
  http.get(`${API_URL}/getRisksList/${userId}/${year}/${month}/${processId}`);

export const getCallRiskEvidenceList = (id) =>
  http.get(`${API_URL}/getRiskEvidenceList/${id}`);

export const getCallRisksResume = (userId, year, month) =>
  http.get(`${API_URL}/getRisksResume/${userId}/${year}/${month}`);

export const getCallOpportunitiesResume = (userId, year, month) =>
  http.get(`${API_URL}/getOpportunitiesResume/${userId}/${year}/${month}`);

export const getCallOpportunity = (opportunityId) =>
  http.get(`${API_URL}/getOpportunity/${opportunityId}`);

export const getCallRisk = (opportunityId) =>
  http.get(`${API_URL}/getRisk/${opportunityId}`);

export const getCallOpportunityEvidenceList = (id) =>
  http.get(`${API_URL}/getOpportunityEvidenceList/${id}`);

export const getCallOpportunityList = (userId, year, month, processId) =>
  http.get(
    `${API_URL}/getOpportunityList/${userId}/${year}/${month}/${processId}`
  );

export const getCallSelfAppraisal = (currentUserId) =>
  http.get(`${API_URL}/getSelfAppraisal/${currentUserId}`);

export const getCallEmployeesInMonitoring = (currentUserId, year, filters = {}) =>
  http.get(`${API_URL}/getEmployeesInMonitoring/${currentUserId}/${year}`, { params: filters });

export const getCallAllEmployeesInMonitoring = (userId, filters = {}) =>
  http.get(`${API_URL}/getAllEmployees/${userId}`, { params: filters });

export const getCallCurrentUser = (userId) =>
  http.get(`${API_URL}/getCurrentUser/${userId}`);

export const getCallManagerReport360GraphData = (userId, year) =>
  http.get(`${API_URL}/getManagerReport360GraphData/${userId}`, { params: { year } });

export const getCallManagerTotal360GraphData = (userId, year) =>
  http.get(`${API_URL}/getManagerTotal360GraphData/${userId}`, { params: { year } });

export const getCallSpecifyReport360GraphData = (userId, year) =>
  http.get(`${API_URL}/getSpecifyReport360GraphData/${userId}`, { params: { year } });

export const getCallReport360Observations = (userId, year) =>
  http.get(`${API_URL}/getReport360Observations/${userId}`, { params: { year } });

export const getCallOrganizationalReport360GraphData = (userId, year) =>
  http.get(`${API_URL}/getOrganizationalReport360GraphData/${userId}`, { params: { year } });

export const getCallPowerBiDetailsByIdAndUserId = (
  idPowerBI,
  valueTab,
  userId,
  month,
  year
) =>
  http.get(
    `${API_URL}/getPowerBiDetailsByIdAndUserId/${idPowerBI}/${valueTab}/${userId}/${month}/${year}`
  );

export const postUpdateEvidenceOpportunity = (data) =>
  http.post(`${API_URL}/updateEvidenceOpportunity`, data);

export const getCallDofaGraph = (userId, yearFilter, fourMonthPeriodFilter) =>
  http.get(
    `${API_URL}/getDofaGraph/${userId}/${yearFilter}/${fourMonthPeriodFilter}`
  );

export const getCallRiskResumeGraph = (
  userId,
  yearFilter,
  fourMonthPeriodFilter
) =>
  http.get(
    `${API_URL}/getRiskResumeGraph/${userId}/${yearFilter}/${fourMonthPeriodFilter}`
  );

export const getCallOpportunityGraph = (userId, yearFilter, monthFilter) =>
  http.get(
    `${API_URL}/getOpportunityGraph/${userId}/${yearFilter}/${monthFilter}`
  );

export const getCallSelectsBiomedicalEquipment = () =>
  http.get(`${API_URL}/getSelects`);

export const getCallSeries = () => http.get(`${API_URL}/getSeries`);

export const getCallBiomedicalEquipmentBySerie = (serieId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentBySerie/${serieId}`);

export const getCallVerifySerie = (serieName) =>
  http.get(`${API_URL}/getVerifySerie/${serieName}`);

export const postSaveSerie = (data) => http.post(`${API_URL}/saveSerie`, data);

export const postAddAccessory = (data) =>
  http.post(`${API_URL}/addAccessory`, data);

export const postEquipementResume = (data) =>
  postLoadFile(`${API_URL}/postEquipementResume`, data);

export const getCallResumeSelects = () =>
  http.get(`${API_URL}/getResumeSelects`);

export const getCallCities = (departmentId) =>
  http.get(`${API_URL}/getCities/${departmentId}`);

export const getCallAccessoryData = (brandId, biomedicalEquipmentId) =>
  http.get(`${API_URL}/getAccessoryData/${brandId}/${biomedicalEquipmentId}`);

export const postAddAccessoryData = (data) =>
  http.post(`${API_URL}/addAccessoryData`, data);

export const postSaveResumeFeature = (data) =>
  http.post(`${API_URL}/saveResumeFeature`, data);

export const getCallResumeFeatureData = (bioEquipmentId) =>
  http.get(`${API_URL}/getResumeFeatureData/${bioEquipmentId}`);

export const getEquipmentInstitutionStatus = (equipmentId) =>
  http.get(`${API_URL}/getEquipmentInstitutionStatus/${equipmentId}`);

export const postSaveBiomedicalFeature = (data) =>
  http.post(`${API_URL}/saveBiomedicalFeature`, data);

const postLoadFile = (url, formData) =>
  http.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const postSaveBiomedicalEquipment = (data) =>
  postLoadFile(`${API_URL}/saveBiomedicalEquipment`, data);

export const getSelectsBiomedical = () =>
  http.get(`${API_URL}/getBiomedicalSelects`);

export const getBiomedicalLocationEquipmentSummary = (locationId, userId) =>
  http.get(`${API_URL}/getBiomedicalLocationEquipmentSummary`, {
    params: { locationId, userId }
  });

export const getBiomedicalCatalogItemSummary = (catalogType, itemId, userId) =>
  http.get(`${API_URL}/getBiomedicalCatalogItemSummary`, {
    params: { catalogType, itemId, userId }
  });

export const getBiomedicalEquipmentModels = (brandId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModels`, {
    params: brandId ? { brandId } : {}
  });

export const getBiomedicalEquipmentModelSummary = (modelId, userId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModelSummary`, {
    params: { modelId, userId }
  });

export const getBiomedicalEquipmentModelResume = (modelId, userId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModelResume`, {
    params: { modelId, userId }
  });

export const putSaveBiomedicalEquipmentModelResume = (data) =>
  http.put(`${API_URL}/saveBiomedicalEquipmentModelResume`, data);

export const getBiomedicalEquipmentModelFeatureData = (modelId, userId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModelFeatureData/${modelId}`, {
    params: { userId }
  });

export const postSaveBiomedicalEquipmentModelFeature = (data) =>
  http.post(`${API_URL}/saveBiomedicalEquipmentModelFeature`, data);

export const postDeleteBiomedicalEquipmentModelFeature = (data) =>
  http.post(`${API_URL}/deleteBiomedicalEquipmentModelFeature`, data);

export const getBiomedicalEquipmentModelInspectionProtocol = (
  modelId,
  userId
) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModelInspectionProtocol`, {
    params: { modelId, userId }
  });

export const getBiomedicalEquipmentModelAdverseEvents = (modelId, userId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModelAdverseEvents`, {
    params: { modelId, userId }
  });

export const getBiomedicalEquipmentModelAccessories = (modelId, userId) =>
  http.get(`${API_URL}/getBiomedicalEquipmentModelAccessories`, {
    params: { modelId, userId }
  });

export const postSaveBiomedicalEquipmentModelInspectionProtocol = (data) =>
  http.post(`${API_URL}/saveBiomedicalEquipmentModelInspectionProtocol`, data);

export const postSaveBiomedicalEquipmentModelAdverseEvent = (data) =>
  http.post(`${API_URL}/saveBiomedicalEquipmentModelAdverseEvent`, data);

export const postSaveBiomedicalEquipmentModelAccessory = (data) =>
  http.post(`${API_URL}/saveBiomedicalEquipmentModelAccessory`, data);

export const postDeleteBiomedicalEquipmentModelInspectionProtocol = (data) =>
  http.post(`${API_URL}/deleteBiomedicalEquipmentModelInspectionProtocol`, data);

export const postDeleteBiomedicalEquipmentModelAdverseEvent = (data) =>
  http.post(`${API_URL}/deleteBiomedicalEquipmentModelAdverseEvent`, data);

export const postDeleteBiomedicalEquipmentModelAccessory = (data) =>
  http.post(`${API_URL}/deleteBiomedicalEquipmentModelAccessory`, data);

export const postAddBiomedicalUbication = (data) =>
  http.post(`${API_URL}/addBiomedicalUbication`, data);

export const putUpdateBiomedicalUbication = (data) =>
  http.put(`${API_URL}/updateBiomedicalUbication`, data);

export const postDeleteOrMigrateBiomedicalLocation = (data) =>
  http.post(`${API_URL}/deleteOrMigrateBiomedicalLocation`, data);

export const postAddBiomedicalCatalogItem = (data) =>
  http.post(`${API_URL}/addBiomedicalCatalogItem`, data);

export const putUpdateBiomedicalCatalogItem = (data) =>
  http.put(`${API_URL}/updateBiomedicalCatalogItem`, data);

export const postDeleteOrMigrateBiomedicalCatalogItem = (data) =>
  http.post(`${API_URL}/deleteOrMigrateBiomedicalCatalogItem`, data);

export const postAddBiomedicalEquipmentModel = (data) =>
  http.post(`${API_URL}/addBiomedicalEquipmentModel`, data);

export const putUpdateBiomedicalEquipmentModel = (data) =>
  http.put(`${API_URL}/updateBiomedicalEquipmentModel`, data);

export const postDeleteBiomedicalEquipmentModel = (data) =>
  http.post(`${API_URL}/deleteBiomedicalEquipmentModel`, data);

export const patchReassignBiomedicalEquipmentModelBrand = (data) =>
  http.patch(`${API_URL}/reassignBiomedicalEquipmentModelBrand`, data);

export const postAddBiomedicalEquipmentState = (data) =>
  http.post(`${API_URL}/addBiomedicalEquipmentState`, data);

export const putUpdateBiomedicalEquipmentState = (data) =>
  http.put(`${API_URL}/updateBiomedicalEquipmentState`, data);

export const postDeleteBiomedicalEquipmentState = (data) =>
  http.post(`${API_URL}/deleteBiomedicalEquipmentState`, data);

export const postAddBiomedicalAdverseEvent = (data) =>
  http.post(`${API_URL}/addBiomedicalAdverseEvent`, data);

export const putUpdateBiomedicalAdverseEvent = (data) =>
  http.put(`${API_URL}/updateBiomedicalAdverseEvent`, data);

export const postDeleteBiomedicalAdverseEvent = (data) =>
  http.post(`${API_URL}/deleteBiomedicalAdverseEvent`, data);

export const postBiomedicaAditions = (data) =>
  http.post(`${API_URL}/postBiomedicaAditions`, data);

export const postSaveInstitution = (data) =>
  http.post(`${API_URL}/saveInstitution`, data);

export const getCallInstitutionById = (institutionId) =>
  http.get(`${API_URL}/getInstitutionById/${institutionId}`);

export const getCallInstitutionList = () =>
  http.get(`${API_URL}/getInstitutionList`);

export const getCallResumeByBioId = (biomedicalId) =>
  http.get(`${API_URL}/getResumeByBioId/${biomedicalId}`);

export const getCallBioEquipmentById = (
  bioEquipmentId,
  userId = null,
  inspectionRecordId = null
) => {
  const params = {};

  if (userId != null) params.userId = userId;
  if (inspectionRecordId != null) params.inspectionRecordId = inspectionRecordId;

  return http.get(`${API_URL}/getBioEquipmentById/${bioEquipmentId}`, {
    params
  });
};
  
export const getInspectionRecordAdditionalImages = (
  inspectionRecordId,
  cacheBust
) => {
  const url = `${API_URL}/getInspectionRecordAdditionalImages/${inspectionRecordId}`;
  const config = cacheBust ? { params: { _t: cacheBust } } : {};

  return http.get(url, config);
};

export const insertInspectionRecordAdditionalImages = (
  data,
  inspectionRecordId
) =>
  postLoadFile(
    `${API_URL}/insertInspectionRecordAdditionalImages/${inspectionRecordId}`,
    data
  );

export const getCallInspectionProtocolData = (bioEquipmentId) =>
  http.get(`${API_URL}/getInspectionProtocolData/${bioEquipmentId}`);

export const postSaveInspectionProtocol = (data) =>
  http.post(`${API_URL}/saveInspectionProtocol`, data)

export const postDeleteInspectionProtocol = (data) =>
  http.post(`${API_URL}/deleteInspectionProtocol`, data);

export const getDevicesInventoryFilters = () =>
  http.get(`${API_URL}/getDevicesInventoryFilter`);

export const getDevicesInventoryPaged = (
  userId,
  page = 1,
  pageSize = 10,
  filters = {}
) =>
  http.get(`${API_URL}/getDevicesInventoryPaged/${userId}`, {
    params: { page, pageSize, ...filters }
  });

export const getDevicesInventoryNotificationsbyUser = (userId) =>
  http.get(`${API_URL}/getDevicesInventoryNotification/${userId}`);

export const getDevicesInventoryNotificationsApprover = () =>
  http.get(`${API_URL}/getDevicesInventoryNotificationsApprover`);

export const getCallInventoryFile = (year) =>
  http.get(`${API_URL}/getInventoryFile/${year}`, {
    responseType: "blob",
  });

export const getCallAvailableInventoryFile = (userId, filters = {}) =>
  http.get(`${API_URL}/getInventoryAvailableFile/${userId}`, {
    params: filters,
    responseType: "blob"
  });

export const getInventoryDownloadYears = () =>
  http.get(`${API_URL}/getInventoryDownloadYears`);

export const getCallInventoryFileByImportMonth = (year, month) =>
  http.get(`${API_URL}/getInventoryFileByImportMonth/${year}/${month}`, {
    responseType: "blob"
  });

export const getCallInventoryFileByImportRange = (startDate, endDate) =>
  http.get(`${API_URL}/getInventoryFileByImportRange`, {
    params: {
      startDate,
      endDate
    },
    responseType: "blob"
  });

export const getCallSelectYear = () => http.get(`${API_URL}/getSelectYear`);

export const postSaveInspectionRecord = (data) =>
  http.post(`${API_URL}/saveInspectionRecord`, data);

export const postRespondInspectionRecord = (data) =>
  http.post(`${API_URL}/respondInspectionRecord`, data);

export const getAdverseEventsBiomedicalEquipment = (biomedicalEquipmentId) =>
  http.get(
    `${API_URL}/getAdverseEventsBiomedicalEquipment/${biomedicalEquipmentId}`
  );

export const addOrUpdateAdverseEventBiomedicalEquipment = (data) =>
  http.post(`${API_URL}/addOrUpdateAdverseEventBiomedicalEquipment`, data);

export const getProtocolActivitySelect = () =>
  http.get(`${API_URL}/getProtocolActivities`);

export const addProtocolActivity = (data) =>
  http.post(`${API_URL}/addProtocolActivity`, data);

export const updateProtocolActivity = (data) =>
  http.put(`${API_URL}/updateProtocolActivity`, data);

export const deleteProtocolActivity = (data) =>
  http.post(`${API_URL}/deleteProtocolActivity`, data);

export const postSaveMacroStrategy = (data) =>
  http.post(`${API_URL}/saveMacroStrategy`, data);

export const getMacroStrategyData = (year, processId) =>
  http.get(`${API_URL}/getMacroStrategy/${year}/${processId}`);

export const getDofaStrategyData = (month, year, processId, state) =>
  http.get(`${API_URL}/getDofaStrategy/${year}/${processId}/${state}/${month}`);

export const getDofaRootAndMonth = (year, processId, month) =>
  http.get(`${API_URL}/getDofaRootAndMonth/${year}/${processId}/${month}`);

export const postDofaStrategy = (data) =>
  http.post(`${API_URL}/saveDofaStrategy`, data);

export const getProcessLeaders = (processId) =>
  http.get(`${API_URL}/getProcessLeaders/${processId}`);

export const getStrategiesDofaBanner = (processId, year, month) =>
  http.get(`${API_URL}/getStrategiesDofaBanner/${processId}`, { params: { year, month } });

export const getDofaYears = (processId, entityType) =>
  http.get(`${API_URL}/getDofaYears/${processId}`, { params: { entityType } });

export const postSaveStrategiesDofaBanner = (data) =>
  http.post(`${API_URL}/saveStrategiesDofaBanner`, data);

export const getCallInternalClientSurvey = (userId) =>
  http.get(`${API_URL}/getInternalClientSurvey/${userId}`);

export const getHeaderBanner = (id) =>
  http.get(`${API_URL}/getHeaderBannerById/${id}`);

export const getAdminBannerData = () =>
  http.get(`${API_URL}/getAdminBannerData`);

export const postSaveAdminBanner = (data) =>
  http.post(`${API_URL}/postSaveAdminBanner`, data);

export const postSaveActivityEvidence = (data) =>
  http.post(`${API_URL}/postSaveActivityEvidence`, data);

export const getActivityEvidenceByUser = (user_id, activity_id) =>
  http.get(`${API_URL}/getActivityEvidenceByUser/${user_id}/${activity_id}`);

export const getPaiEvidencebyId = (id) =>
  http.get(`${API_URL}/getPaiEvidencebyId/${id}`);

export const postPaiEvidence = (data) =>
  http.post(`${API_URL}/postPaiEvidence`, data);

export const postVerificationRisk = (data) =>
  http.post(`${API_URL}/postVerificationRisk`, data);

export const postUpdateRiskAction = (data) =>
  http.post(`${API_URL}/postUpdateRiskAction`, data);

export const getRiskActionsByRiskMonthId = (risk_month_id) =>
  http.get(`${API_URL}/getRiskActionsByRiskMonthId/${risk_month_id}`);

export const postUpdateOpportunityAction = (data) =>
  http.post(`${API_URL}/postUpdateOpportunityAction`, data);

export const getOpportunityAction = (opportunity_month_id) =>
  http.get(`${API_URL}/getOpportunityAction/${opportunity_month_id}`);

export const postUpdateRiskUpdateDate = (data) =>
  http.post(`${API_URL}/updateRiskUpdateDate`, data);

export const postUpdateOportunityUpdateDate = (data) =>
  http.post(`${API_URL}/updateOportunityUpdateDate`, data);

export const getAccompaniment = (id) =>
  http.get(`${API_URL}/getAccompaniment/${id}`);

export const getAccompanimentSelects = (userId = null) =>
  http.get(
    `${API_URL}/getAccompanimentSelects${userId != null ? `?userId=${userId}` : ""}`
  );

export const getBusinessLineSelect = (userId) =>
  http.get(`${API_URL}/getBusinessLineSelect/${userId}`);

export const getPriorCommitment = (userId, lineId, accompanimentId) =>
  http.get(
    `${API_URL}/getPriorCommitment/${userId}/${lineId}/${accompanimentId}`
  );

export const getPlannedOrganized = (accompanimentId) =>
  http.get(`${API_URL}/getPlannedOrganized/${accompanimentId}`);

export const getSpinTechnique = (accompanimentId) =>
  http.get(`${API_URL}/getSpinTechnique/${accompanimentId}`);

export const getPromotionalAspects = (accompanimentId) =>
  http.get(`${API_URL}/getPromotionalAspects/${accompanimentId}`);

export const getAccompanimentList = (
  dateFilter,
  yearFilter,
  userExecutiveId,
  userLeaderId,
  keyAccompaniment,
  status,
  userId = null
) =>
  http.get(
    `${API_URL}/getAccompanimentList/${dateFilter}/${yearFilter}/${userExecutiveId}/${userLeaderId}/${keyAccompaniment}/${status}${userId != null ? `?userId=${userId}` : ""}`
  );

export const postSaveAccompaniment = (data) =>
  http.post(`${API_URL}/saveAccompaniment`, data);

export const postSavePromotionalAspects = (data) =>
  http.post(`${API_URL}/savePromotionalAspects`, data);

export const postSavePlannedOrganized = (data) =>
  http.post(`${API_URL}/savePlannedOrganized`, data);

export const postSaveSpinTechnique = (data) =>
  http.post(`${API_URL}/saveSpinTechnique`, data);

export const getFilterSelects = (userId) =>
  http.get(`${API_URL}/getFilterSelects/${userId}`);

export const getSelectsServiceOrder = () =>
  http.get(`${API_URL}/getSelectsServiceOrder`);

export const getSelectsByBrand = (brandId) =>
  http.get(`${API_URL}/getSelectsByBrand/${brandId}`);

export const getBiomedicalDataByIspectionRecordId = (inspectionRecordId) =>
  http.get(
    `${API_URL}/getBiomedicalDataByIspectionRecordId/${inspectionRecordId}`
  );

export const getSelectsByEquipment = (equipmentId) =>
  http.get(`${API_URL}/getSelectsByEquipment/${equipmentId}`);

export const getSeriesByModel = (model) =>
  http.get(`${API_URL}/getSeriesByModel/${model}`);

export const getServiceOrderById = (id) =>
  http.get(`${API_URL}/getServiceOrderById/${id}`);

export const getDataByServiceOrderId = (serviceOrderId) =>
  http.get(`${API_URL}/getDataByServiceOrderId/${serviceOrderId}`);

export const getServiceOrderTableData = (userId, isManagment, params) =>
  http.get(`${API_URL}/getServiceOrderTableData/${userId}/${isManagment}`, { params });

export const getHistoryData = (userId, isManagment, page, itemsPerPage) =>
  http.get(
    `${API_URL}/getHistoryData/${userId}/${isManagment}/${page}/${itemsPerPage}`
  );

export const updateServiceOrderEngineer = (data) =>
  http.post(`${API_URL}/updateServiceOrderEngineer`, data);

export const getOrderStateByOrderActivity = (activity_id) =>
  http.get(`${API_URL}/getOrderStateByOrderActivity/${activity_id}`);

export const getServiceOrderNotification = (userId) =>
  http.get(`${API_URL}/getServiceOrderNotification/${userId}`);

export const getNonBusinessDay = (userId) =>
  http.get(`${API_URL}/getNonBusinessDay`);

export const getActivitiesEngineering = (engineeringActId) =>
  http.get(`${API_URL}/getActivitiesEngineering/${engineeringActId}`);

export const saveActivityEngineering = (data) =>
  http.post(`${API_URL}/saveActivityEngineering`, data);

export const saveEngineeringActActivity = (data) =>
  http.post(`${API_URL}/saveEngineeringActActivity`, data);

export const getExistEngeneeringAct = (serviceOrderId) =>
  http.get(`${API_URL}/existEngeneeringAct/${serviceOrderId}`);

export const saveEngineeringActImages = (data) =>
  http.post(`${API_URL}/saveEngineeringActImages`, data);

export const getEngineeringActImages = (engineeringActId, cacheBust) => {
  const url = `${API_URL}/getEngineeringActImages/${engineeringActId}`;
  const config = cacheBust ? { params: { _t: cacheBust } } : {};
  return http.get(url, config);
};

export const insertEngineeringActImages = (data, engineeringActId) =>
  postLoadFile(
    `${API_URL}/saveEngineeringActImages?engineeringActId=${engineeringActId}`,
    data
  );

export const deleteEngineeringActImage = (imageId) =>
  http.get(`${API_URL}/deleteEngineeringActImage/${imageId}`);

export const getEngineeringActsTable = (userId, userRole, params) =>
  http.get(`${API_URL}/getEngineeringActs/${userId}/${userRole}`, { params });

export const getEngineeringActById = (getEngineeringActById) =>
  http.get(`${API_URL}/getEngineeringActById/${getEngineeringActById}`);

export const getEngineeringActSparePartsTable = (engineeringActId) =>
  http.get(`${API_URL}/getEngineeringActSpareParts/${engineeringActId}`);

export const getSpareParts = () => http.get(`${API_URL}/getSpareParts`);

export const createOrUpdateSparePart = (data) =>
  http.post(`${API_URL}/createOrUpdateSparePart`, data);

export const deleteEngineeringActSparePart = (id) =>
  http.get(`${API_URL}/deleteEngineeringActSparePart/${id}`);

export const saveEngineeringAct = (data) =>
  http.post(`${API_URL}/saveEngineeringAct`, data);

export const generateEngineeringReportPDF = (id) =>
  http.get(`${API_URL}/generateEngineeringReportPDF/${id}`);

export const postUploadData = (data) =>
  http.post(`${API_URL}/postUploadData`, data);

export const postLoadEngineeringReportFile = (data) =>
  postLoadFile(`${API_URL}/postLoadEngineeringReportFile`, data);

export const downloadEngineeringReportPDF = (engineeringActId) =>
  http.get(`${API_URL}/downloadEngineeringReportPDF/${engineeringActId}`);

export const getBiomedicalEquipmentBySeriesList = (serieIds) =>
  http.post(`${API_URL}/getBiomedicalEquipmentBySeries`, serieIds);

export const getEngineeringActivityInfo = (activityId, table_id) =>
  http.get(`${API_URL}/getEngineeringActivityInfo/${activityId}/${table_id}`);

export const getServiceOrdersAnualChartData = (
  mode,
  year,
  month,
  order_activity_id,
  institution_id,
  engineer_id
) =>
  http.get(
    `${API_URL}/getServiceOrdersChartData/${mode}/${year}/${month}/${order_activity_id}/${institution_id}/${engineer_id}`
  );

export const getFilteredServiceOrdersAnualChartData = (filters) =>
  http.post(`${API_URL}/getFilteredServiceOrdersChartData`, filters);

export const getServiceOrderDateRange = () =>
  http.get(`${API_URL}/getServiceOrderDateRange`);

export const getServiceOrderDurationByEngineerData = (
  engineerId,
  activityId,
  selectedMonth
) =>
  http.get(
    `${API_URL}/getServiceOrderDurationByEngineer/${engineerId}/${activityId}/${selectedMonth}`
  );

export const getHistoryDataByServiceOrderId = (
  userId,
  isManagment,
  page,
  itemsPerPage
) =>
  http.get(
    `${API_URL}/getHistoryData/${userId}/${isManagment}/${page}/${itemsPerPage}`
  );

export const getHistoryDataByServiceOrderList = (
  serviceOrderId,
  page,
  itemsPerPage
) =>
  http.get(
    `${API_URL}/getHistoryDataByServiceOrderId/${serviceOrderId}/${page}/${itemsPerPage}`
  );

export const getStrategiesSelect = (processId, year, month) =>
  http.get(`${API_URL}/getStrategiesSelect/${processId}/${year}/${month}`);

export const getServiceOrderAnalysisData = (activityId, params = {}) => {
  const queryParams = { year: params.year };
  if (
    params.month != null &&
    params.month !== "" &&
    params.month !== "all"
  ) {
    queryParams.month = params.month;
  }
  return http.get(`${API_URL}/getServiceOrderAnalysis/${activityId}`, {
    params: queryParams
  });
};

export const addOrUpdateServiceOrderAnalysis = (data) =>
  http.post(`${API_URL}/addOrUpdateServiceOrderAnalysis`, data);

export const getTableIndicatorAnalysisByTime = (activityId, params = {}) => {
  const queryParams = { year: params.year };
  if (
    params.month != null &&
    params.month !== "" &&
    params.month !== "all"
  ) {
    queryParams.month = params.month;
  }
  return http.get(`${API_URL}/getTableIndicatorAnalysisByTime/${activityId}`, {
    params: queryParams
  });
};

export const getRegisterIndicatorAnalysisByTime = (month, activityId) =>
  http.get(
    `${API_URL}/getRegisterIndicatorAnalysisByTime/${month}/${activityId}`
  );

export const saveRegisterIndicatorAnalysisByTime = (dataToSend) =>
  http.post(`${API_URL}/saveRegisterIndicatorAnalysisByTime`, dataToSend);

export const getAnalisisIndicatorAnalysisByGoal = (month, activityId) =>
  http.get(
    `${API_URL}/getAnalisisIndicatorAnalysisByGoal/${month}/${activityId}`
  );

export const getPilarsStakeholders = () =>
  http.get(`${API_URL}/getPilarsStakeholders`);

export const addOrUpdateStakeholdersByProcess = (data) =>
  http.post(`${API_URL}/addOrUpdateStakeholdersByProcess`, data);

export const getNationalSuppliers = () =>
  http.get(`${API_URL}/getNationalSuppliers`);

export const deleteNationalSupplier = (id) =>
  http.post(`${API_URL}/deleteNationalSupplier`, id);

export const getInternationalSuppliers = () =>
  http.get(`${API_URL}/getInternationalSuppliers`);

export const deleteInternationalSuppliers = (id) =>
  http.post(`${API_URL}/deleteInternationalSuppliers`, id);

export const addOrUpdateServiceSuppliers = (data) =>
  http.post(`${API_URL}/addOrUpdateServiceSuppliers`, data);

export const getServiceSuppliers = () =>
  http.get(`${API_URL}/getServiceSuppliers`);

export const deleteServiceSupplier = (id) =>
  http.post(`${API_URL}/deleteServiceSupplier`, id);

export const getPilarSuppliersGraph = () =>
  http.get(`${API_URL}/getPilarSuppliersGraph`);

//==================== seralogin online ====================

export const getPortfolioStatusReportData = (month, year) =>
  http.get(`${API_URL}/getPortfolioStatusReportData/${month}/${year}`); //cartera

export const getProductPerformanceIndicatorData = (product, month, year) =>
  http.get(
    `${API_URL}/getProductPerformanceIndicatorData/${product}/${month}/${year}`
  );

export const getSalesPerformanceData = (indicator, month, year) =>
  http.get(`${API_URL}/getSalesPerformanceData/${indicator}/${month}/${year}`);

export const postMassiveUpload = (formData) =>
  http.post(`${API_URL}/massiveUpload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getBudgetByYear = (year) =>
  http.get(`${API_URL}/getBudgetByYear/${year}`);
export const getPilarStakeholdersByProcess = (id) =>
  http.get(`${API_URL}/getPilarStakeholdersByProcess/${id}`);

export const createUpdateStakeholdersByProcess = (data) =>
  http.post(`${API_URL}/createUpdateStakeholdersByProcess`, data);

export const deleteInterestedParty = (data) =>
  http.post(`${API_URL}/deleteInterestedParty`, data);

export const getStakeholdersByTypeId = (stakeholders_id) =>
  http.get(`${API_URL}/getStakeholdersByType/${stakeholders_id}`);

export const getStakeholdersExternal = () =>
  http.get(`${API_URL}/getStakeholdersExternal`);

export const getStakeholdersExternalRequirements = (id) =>
  http.get(`${API_URL}/getStakeholdersExternalRequirements/${id}`);

export const createUpdateStakeholdersExernalByProcess = (data) =>
  http.post(`${API_URL}/createUpdateStakeholdersExternal`, data);

export const deleteStakeholdersExternalRequirement = (data) =>
  http.post(`${API_URL}/deleteStakeholdersExternalRequirement`, data);

export const createUpdateStakeholdersExternalRequirement = (data) =>
  http.post(`${API_URL}/createUpdateStakeholdersExternalRequirement`, data);

export const deleteStakeholdersExternal = (data) =>
  http.post(`${API_URL}/deleteStakeholdersExternal`, data);

export const updateStakeholdersExternal = (data) =>
  http.post(`${API_URL}/updateStakeholdersExternal`, data);

export const updateStakeholdersInternal = (data) =>
  http.post(`${API_URL}/updateStakeholdersInternal`, data);

export const getStakeholdersInternal = () =>
  http.get(`${API_URL}/getStakeholdersInternal`);

export const getStakeholdersInternalRequirements = (id) =>
  http.get(`${API_URL}/getStakeholdersInternalRequirements/${id}`);

export const createUpdateStakeholdersInternal = (data) =>
  http.post(`${API_URL}/createUpdateStakeholdersInternal`, data);

export const createUpdateStakeholdersInternalRequirement = (data) =>
  http.post(`${API_URL}/createUpdateStakeholdersInternalRequirement`, data);

export const deleteStakeholdersInternalRequirement = (data) =>
  http.post(`${API_URL}/deleteStakeholdersInternalRequirement`, data);

export const deleteStakeholdersInternal = (data) =>
  http.post(`${API_URL}/deleteStakeholdersInternal`, data);

export const generateBiomedicalResumePDF = (biomedicalId) =>
  http.get(`${API_URL}/generateBiomedicalResumePDF/${biomedicalId}`);

export const generateTechnicalInspectionActPDF = (
  biomedicalId,
  inspectionRecordId = null,
  requestContext = {}
) =>
  http.get(`${API_URL}/generateTechnicalInspectionActPDF/${biomedicalId}`, {
    params: {
      ...(inspectionRecordId != null ? { inspectionRecordId } : {}),
      ...requestContext
    }
  });

export const addOrUpdateNationalSuppliers = (data) =>
  http.post(`${API_URL}/addOrUpdateNationalSuppliers`, data);

export const addOrUpdateNationalSuppliersProduct = (data) =>
  postLoadFile(`${API_URL}/addOrUpdateNationalSuppliersProduct`, data);

export const deleteSuppliersProduct = (data) =>
  http.post(`${API_URL}/deleteSuppliersProduct`, data);

export const getProductsBySupplier = (id, type) =>
  http.get(`${API_URL}/getProductsBySupplier/${id}/${type}`);

export const addOrUpdateInternationalSuppliers = (data) =>
  http.post(`${API_URL}/addOrUpdateInternationalSuppliers`, data);

export const addOrUpdateInternationalSuppliersProduct = (data) =>
  postLoadFile(`${API_URL}/addOrUpdateInternationalSuppliersProduct`, data);

export const getStrategyAndDofas = (strategyId) =>
  http.get(`${API_URL}/getStrategyAndDofas/${strategyId}`);

export const getStakeholdersDates = () =>
  http.get(`${API_URL}/getStakeholdersDates`);

export const saveStakeholdersDates = (data) =>
  http.post(`${API_URL}/saveStakeholdersDates`, data);

export const postCreateInterestedParties = (data) =>
  http.post(`${API_URL}/postCreateInterestedParties`, data);

export const getInterestedPartiesByProcess = (process_id) =>
  http.get(`${API_URL}/getInterestedPartiesByProcess/${process_id}`);

export const getInterestedPartiesUpdateHistory = (process_id, params = {}) => {
  const search = new URLSearchParams();
  if (params.page != null) search.set("page", String(params.page));
  if (params.limit != null) search.set("limit", String(params.limit));
  if (params.search != null && String(params.search).trim() !== "") {
    search.set("search", String(params.search).trim());
  }
  const qs = search.toString();
  return http.get(
    `${API_URL}/getInterestedPartiesUpdateHistory/${process_id}${
      qs ? `?${qs}` : ""
    }`
  );
};

export const getInterestedPartiesGraphData = () =>
  http.get(`${API_URL}/getInterestedPartiesGraphData`);

export const getInterestedPartiesProcessDashboard = () =>
  http.get(`${API_URL}/getInterestedPartiesProcessDashboard`);

export const getLastUpdatedInterestedParty = (process_id) =>
  http.get(`${API_URL}/getLastUpdatedInterestedParty/${process_id}`);

export const createInterestedPartiesComment = (data) =>
  http.post(`${API_URL}/createInterestedPartiesComment`, data);

export const getInterestedPartiesCommentsByProcess = (
  process_id,
  interested_parties_id
) =>
  http.get(
    `${API_URL}/getInterestedPartiesCommentsByProcess/${process_id}/${interested_parties_id}`
  );

export const addOrUpdateServiceOrder = (data) =>
  postLoadFile(`${API_URL}/addOrUpdateServiceOrder`, data);

export const updateServiceOrderState = (data) =>
  postLoadFile(`${API_URL}/updateServiceOrderState`, data);

export const biomedicalManagementGetLastUpdate = () =>
  http.get(`${API_URL}/getLastUpdate`);

export const biomedicalManagementGetChangeLogByEquipment = (id) =>
  http.get(`${API_URL}/getChangeLogByEquipment/${id}`);

export const getServiceOrderDurationByOrder = (
  mode,
  year,
  month,
  order_activity_id,
  institution_id,
  engineer_id
) =>
  http.get(
    `${API_URL}/getServiceOrderDurationByOrder/${mode}/${year}/${month}/${order_activity_id}/${institution_id}/${engineer_id}`
  );

export const postMassiveUploadInventary = (formData, year) =>
  http.post(`${API_URL}/massiveUploadInventary/${year}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const getEngineeringActExistence = (service_order_id) =>
  http.get(`${API_URL}/getEngineeringActExistence/${service_order_id}`);

export const getRequestValidation = (data) =>
  http.post(`${API_URL}/getRequestValidation`, data);

export const getTaskData = (userId) =>
  http.get(`${API_URL}/getTaskData/${userId}`);

export const createUpdateTask = (data) =>
  http.post(`${API_URL}/createUpdateTask`, data);

export const reorderTaskPosition = (payload) =>
  http.patch(`${API_URL}/reorderTaskPosition`, payload);

export const completeTask = (data) =>
  http.post(`${API_URL}/completeTask`, data);

export const getServiceOrderAnalysisbyTableId = (table_id, params = {}) => {
  const queryParams = { year: params.year };
  if (
    params.month != null &&
    params.month !== "" &&
    params.month !== "all"
  ) {
    queryParams.month = params.month;
  }
  return http.get(`${API_URL}/getServiceOrderAnalysisbyTableId/${table_id}`, {
    params: queryParams
  });
};

export const getServiceOrderAnalysisYearsByTableId = (table_id, params = {}) =>
  http.get(`${API_URL}/getServiceOrderAnalysisYearsByTableId/${table_id}`, {
    params: { activityId: params.activityId }
  });

export const getAnalisisIndicatorTecnology = (month, table_id) =>
  http.get(`${API_URL}/getAnalisisIndicatorTecnology/${month}/${table_id}`);

export const getServiceOrderDowntimeIndicator = (
  year,
  month,
  order_activity_id
) =>
  http.get(
    `${API_URL}/getServiceOrderDowntimeIndicator/${year}/${month}/${order_activity_id}`
  );

export const getOverThresholdCount = (year, month) =>
  http.get(`${API_URL}/getOverThresholdCountNotification/${year}/${month}`);

export const getImportRegistrationTable = (page, supplier_id, year, month) =>
  http.get(
    `${API_URL}/getImportRegistrationTable/${page}/${supplier_id}/${year}/${month}`
  );

export const getImportRegistrationNotification = () =>
  http.get(`${API_URL}/getImportRegistrationNotification`);

export const getExpiringImportRegistrations = () =>
  http.get(`${API_URL}/getExpiringImportRegistrations`);

export const getImportRegistrationYears = () =>
  http.get(`${API_URL}/getImportRegistrationYears`);

export const addOrUpdateImportRegistration = (data) =>
  postLoadFile(`${API_URL}/addOrUpdateImportRegistration`, data);

export const deleteImportRegistration = (id) =>
  http.delete(`${API_URL}/deleteImportRegistration/${id}`);

export const getBrandForeignTradeSelect = () =>
  http.get(`${API_URL}/getBrandForeignTradeSelect`);

export const getSuppliersForeignTrade = () =>
  http.get(`${API_URL}/getSuppliersForeignTrade`);

export const getAnnualProjectionYears = () =>
  http.get(`${API_URL}/foreignTrade/annualProjection/years`);

export const getAnnualProjectionsByYear = (year) =>
  http.get(`${API_URL}/foreignTrade/annualProjection`, { params: { year } });

export const createOrUpdateAnnualProjection = (data) =>
  http.post(`${API_URL}/foreignTrade/annualProjection/save`, data);

export const deleteAnnualProjection = (id) =>
  http.delete(`${API_URL}/foreignTrade/annualProjection/${id}`);

export const getImportExecutionSummary = (year) =>
  http.get(`${API_URL}/foreignTrade/importExecution/summary`, { params: { year } });

export const getImportExecutionCauses = () =>
  http.get(`${API_URL}/foreignTrade/importExecution/causes`);

export const getImportExecutionsByMonth = (year, month) =>
  http.get(`${API_URL}/foreignTrade/importExecution/list`, { params: { year, month } });

export const createOrUpdateImportExecution = (data) =>
  http.post(`${API_URL}/foreignTrade/importExecution/save`, data);

export const deleteImportExecution = (id) =>
  http.delete(`${API_URL}/foreignTrade/importExecution/${id}`);

export const saveNewSupplier = (data) =>
  http.post(`${API_URL}/addOrUpdateSupplierForeignTrade`, data);

export const syncImportRegistrationStates = () =>
  http.post(`${API_URL}/syncImportRegistrationStates`);

export const checkImportRegistrationDuplicate = (supplier_id, product) =>
  http.get(
    `${API_URL}/checkImportRegistrationDuplicate/${supplier_id}/${product}`
  );

export const checkImportRegistrationNumber = (registration_number, exclude_id) =>
  http.get(
    `${API_URL}/checkImportRegistrationNumber?registration_number=${encodeURIComponent(registration_number ?? "")}&exclude_id=${exclude_id ?? ""}`
  );
  
export const saveAnalysisDowntimeIndicator = (dataToSend) =>
  http.post(`${API_URL}/saveAnalysisDowntimeIndicator`, dataToSend);

export const getTableDowntimeIndicator = () =>
  http.get(`${API_URL}/getTableDowntimeIndicator`);

export const getDowntimeMonthlyKpi = (month) =>
  http.get(`${API_URL}/getDowntimeMonthlyKpi/${month}`);

export const getBiomedicalTemplate = () =>
  http.get(`${API_URL}/templates/biomedical-template`, {
    responseType: "blob",
  });

export const manageTimeCreateTask = (data) =>
  http.post(`${API_URL}/manageTimeCreateTask`, data);

export const manageTimeEditTask = (data) =>
  http.post(`${API_URL}/manageTimeEditTask`, data);

export const rolloverTask = () => http.get(`${API_URL}/rolloverNonContinuous`);

export const getTasks = (params = {}) =>
  http.get(`${API_URL}/getTasks`, { params });

const sectionToParams = (sectionId, opts = {}) => {
  const {
    date,
    search,
    employer_id,
    process_id,
    state,
    pending_page,
    completed_page,
    pending_pageSize,
    completed_pageSize,
  } = opts;

  const base = {
    date,
    search,
    employer_id,
    process_id,
    state,
    pending_page,
    completed_page,
    pending_pageSize,
    completed_pageSize,
  };

  const temporalScopes = {
    diaria: "day",
    semanal: "week",
    mensual: "month",
    anual: "year",
  };

  if (["diaria", "semanal", "mensual", "anual"].includes(sectionId)) {
    return { scope: temporalScopes[sectionId], ...base };
  }
  if (["A", "B", "C", "D"].includes(sectionId)) {
    return { scope: "classification", calification: sectionId, ...base };
  }
  return { scope: "day", ...base };
};

export const getTasksView = (sectionId, opts = {}) => {
  const params = sectionToParams(sectionId, opts);
  return http.get(`${API_URL}/getTasks`, { params });
};

export const getSearchTasks = (q, page = 1, pageSize = 15, extra = {}) => {
  return http.get(`${API_URL}/searchTasks`, {
    params: { q, page, pageSize, ...extra },
  });
};

export const getPendingTask = (userId) =>
  http.get(`${API_URL}/tasks/pendingCounts/${userId}`);

export const getTaskTimeCounts = (params) => {
  return http.get(`${API_URL}/tasks/timeCounts`, { params });
};

export const getTaskDaysTable = (taskId) => {
  return http.get(`${API_URL}/tasks/${taskId}/days`);
};

export const getAssignableUsersList = (userId, all = false) => {
  return http.get(`${API_URL}/tasks/assignees/${userId}/${all}`);
};

export const getNotificationsTask = (user_id) =>
  http.get(`${API_URL}/tasks/getNotifications/${user_id}`);

export const markAsReadTaskNotification = (dataToSend) =>
  http.post(`${API_URL}/tasks/markAsRead`, dataToSend);

export const getAllTaskManagerUsers = (q = "") =>
  http.get(`${API_URL}/tasks/assignees`, {
    params: {
      mode: "global",
      q,
    },
  });

export const getDailyTasksByUser = (params) =>
  http.get(`${API_URL}/tasks/daily`, { params });

export const postJustifyTaskDay = (data) =>
  http.post(`${API_URL}/tasks/justifyDay`, data);

export const getProcessIdFromUser = (user_id, all = false) =>
  http.get(`${API_URL}/tasks/getProcessIdFromUser/${user_id}/${all}`);

export const rolloverContinuousTask = () =>
  http.get(`${API_URL}/rolloverContinuous`);

export const deleteTask = (data) => http.post(`${API_URL}/deleteTask`, data);

export const getindicatorsExecutedvsProjected = (dates) =>
  http.get(
    `${API_URL}/task/indicators/executedvsProjected/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}`
  );

export const getExecutedVsProjectedDetail = (dates, page = 1, pageSize = 10) =>
  http.get(
    `${API_URL}/task/indicators/getExecutedVsProjectedDetail/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}/${page}/${pageSize}`
  );

export const getTaskYears = () =>
  http.get(`${API_URL}/task/indicators/getTaskYears`);

export const downloadTaskMonthlyReport = (year, month, opts = {}) => {
  const params = {};
  if (opts.user_id) params.user_id = opts.user_id;
  if (opts.process_id != null && opts.process_id !== "") {
    params.process_id = opts.process_id;
  }
  if (opts.start_date) params.start_date = opts.start_date;
  if (opts.end_date) params.end_date = opts.end_date;

  return http.get(`${API_URL}/tasks/download/${year}/${month}`, {
    responseType: "blob",
    params: Object.keys(params).length ? params : undefined
  });
};

export const getPlannedNotExecutedIndicators = (dates) =>
  http.get(
    `${API_URL}/task/indicators/getPlannedNotExecutedIndicators/${dates.start_date}/${dates.end_date}/${dates.user_id}/`
  );

export const getPlannedNotExecutedData = (data) =>
  http.get(
    `${API_URL}/task/indicators/getPlannedNotExecutedData/${data.start_date}/${data.end_date}/${data.user_id}/${data.page}/${data.pageSize}`
  );

export const getindicatorsExecutedvsNoProjected = (dates) =>
  http.get(
    `${API_URL}/task/indicators/executedvsNoProjected/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}`
  );

export const getExecutedVsNoProjectedDetail = (
  dates,
  page = 1,
  pageSize = 10
) =>
  http.get(
    `${API_URL}/task/indicators/getExecutedVsNoProjectedDetail/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}/${page}/${pageSize}`
  );

export const getIndicatorUnplannedExecuted = (dates) =>
  http.get(
    `${API_URL}/task/indicators/unplannedExecuted/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}`
  );

export const getIndicatorUnplannedExecutedDetails = (
  dates,
  page = 1,
  pageSize = 10
) =>
  `${API_URL}/task/indicators/getIndicatorUnplannedExecutedDetails/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}/${page}/${pageSize}`;

export const getIndicatorTaskDeletedData = (dates) =>
  http.get(
    `${API_URL}/task/indicators/getIndicatorTaskDeleted/` +
    `${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}`
  );

export const getIndicatorTaskDeletedDetail = (dates, page = 1, pageSize = 10) =>
  http.get(
    `${API_URL}/task/indicators/getIndicatorTaskDeletedDetails/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${dates.user_id}/${page}/${pageSize}`
  );

function managementParams(dates) {
  const params = {};
  if (dates.user_id) params.user_id = dates.user_id;
  if (dates.process_id != null && dates.process_id !== "") params.process_id = dates.process_id;
  return Object.keys(params).length ? { params } : {};
}

export const getManagementExecutedVsProjectedByProcess = (dates) =>
  http.get(
    `${API_URL}/task/indicators/getManagementExecutedVsProjectedByProcess/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}`,
    managementParams(dates)
  );

export const getManagementTableExecutedVsProjectedByProcessData = (
  dates,
  page = 1,
  pageSize = 10
) =>
  http.get(
    `${API_URL}/task/indicators/getManagementTableExecutedVsProjectedByProcess/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${page}/${pageSize}`,
    managementParams(dates)
  );

export const getManagementChartExecutedVsNOProjectedByProcessData = (dates) =>
  http.get(
    `${API_URL}/task/indicators/getManagementChartExecutedVsNOProjectedByProcess/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}`,
    managementParams(dates)
  );

export const getManagementExecutedVsNOProjectedByProcess = (
  dates,
  page = 1,
  pageSize = 10
) =>
  http.get(
    `${API_URL}/task/indicators/getManagementExecutedVsNOProjectedByProcess/${dates.year}/${dates.month}/${dates.start_date}/${dates.end_date}/${page}/${pageSize}`,
    managementParams(dates)
  );
export const postWalletUpload = (formData, userId) => {
  formData.append("userId", userId);
  return http.post(`${API_URL}/wallet/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getWalletHistory = (year, month, line, page = 1, pageSize = 10, userId) =>
  http.get(
    `${API_URL}/wallet/history/${year}/${month}/${line}/${page}/${pageSize}`,
    { params: { userId } }
  );

export const getProductLine = (userId) =>
  http.get(`${API_URL}/wallet/getProductLine`, { params: { userId } });

export const getWalletProducts = ({
  page = 1,
  pageSize = 15,
  search = "",
  lineId = null,
  userId
} = {}) => {
  const params = new URLSearchParams();
  params.set("page", page);
  params.set("pageSize", pageSize);
  params.set("userId", userId);
  if (search) params.set("search", search);
  if (lineId && lineId !== "null") params.set("lineId", lineId);
  return http.get(`${API_URL}/wallet/products?${params.toString()}`);
};

export const getWalletProductById = (id, userId) =>
  http.get(`${API_URL}/wallet/products/${id}`, { params: { userId } });

export const createWalletProduct = (payload, userId) =>
  http.post(`${API_URL}/wallet/products`, { ...payload, userId });

export const updateWalletProduct = (id, payload, userId) =>
  http.put(`${API_URL}/wallet/products/${id}`, { ...payload, userId });

export const deleteWalletProduct = (id, userId) =>
  http.delete(`${API_URL}/wallet/products/${id}`, { params: { userId } });

export const downloadWalletZip = (walletId, userId) =>
  http.get(`${API_URL}/wallet/downloadZip/${walletId}`, {
    responseType: "blob",
    params: { userId }
  });

export const getNationalizationTimeData = (provider, mes, año, page = 1, pageSize = 10) => {
  const params = new URLSearchParams();
  if (provider && provider !== 'null' && provider !== '') params.append('provider', provider);
  if (mes && mes !== 'null' && mes !== '') params.append('mes', mes);
  if (año && año !== 'null' && año !== '') params.append('año', año);
  params.append('page', page);
  params.append('pageSize', pageSize);

  return http.get(
    `${API_URL}/foreignTrade/nationalizationTime?${params.toString()}`
  );
};

export const getProviders = () =>
  http.get(`${API_URL}/foreignTrade/nationalizationTime/providers`);

export const getCountries = () =>
  http.get(`${API_URL}/foreignTrade/nationalizationTime/countries`);

export const getTransportModes = () =>
  http.get(`${API_URL}/foreignTrade/nationalizationTime/transportModes`);

export const getNationalizationTimeById = (id) =>
  http.get(`${API_URL}/foreignTrade/nationalizationTime/${id}`);

export const createOrUpdateNationalizationTime = (data) =>
  http.post(`${API_URL}/foreignTrade/nationalizationTime/save`, data);

export const uploadNationalizationTimeFiles = (importId, files) => {
  const formData = new FormData();
  formData.append('importId', importId);
  files.forEach((file) => {
    formData.append('files', file);
  });
  return http.post(`${API_URL}/foreignTrade/nationalizationTime/uploadFiles`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: "blob",
  });
};

export const deleteNationalizationTimeFile = (id) =>
  http.post(`${API_URL}/foreignTrade/nationalizationTime/deleteFile/${id}`);

export const getInternalClientSatisfactionData = (orderNumber, quarter, year, page = 1, pageSize = 10) => {
  const params = new URLSearchParams();
  if (orderNumber && orderNumber !== 'null' && orderNumber !== '') params.append('orderNumber', orderNumber);
  if (quarter && quarter !== 'null' && quarter !== '') params.append('quarter', quarter);
  if (year && year !== 'null' && year !== '') params.append('year', year);
  params.append('page', page);
  params.append('pageSize', pageSize);

  return http.get(
    `${API_URL}/foreignTrade/internalClientSatisfaction?${params.toString()}`
  );
};

export const getInternalClientSatisfactionQuestions = () =>
  http.get(`${API_URL}/foreignTrade/internalClientSatisfaction/questions`);

export const updateInternalClientSatisfactionQuestions = (payload) =>
  http.post(`${API_URL}/foreignTrade/internalClientSatisfaction/questions/update`, payload);

export const getOrderNumbersForSurvey = () =>
  http.get(`${API_URL}/foreignTrade/internalClientSatisfaction/orderNumbers`);

export const checkSurveyExists = (importId) =>
  http.get(`${API_URL}/foreignTrade/internalClientSatisfaction/checkSurvey?importId=${importId}`);

 

export const generateSurveyLink = (importId) =>
  http.post(`${API_URL}/foreignTrade/internalClientSatisfaction/generateLink`, { importId });

export const getSurveyByOrderId = (surveyOrderId, userId) => {
  const params = new URLSearchParams();
  if (userId) params.append('userId', userId);
  return http.get(`${API_URL}/foreignTrade/internalClientSatisfaction/national/survey/${surveyOrderId}?${params.toString()}`);
};

export const submitSurveyAnswers = (surveyOrderId, data) =>
  http.post(`${API_URL}/foreignTrade/internalClientSatisfaction/national/survey/${surveyOrderId}/answers`, data);

export const getSurveyAnswerById = (answerId) =>
  http.get(`${API_URL}/foreignTrade/internalClientSatisfaction/answer/${answerId}`);

// External (International) Client Satisfaction - filtro por Cliente
export const getExternalClientSatisfactionData = (clientName, year, page = 1, pageSize = 10) => {
  const params = new URLSearchParams();
  if (clientName && clientName !== 'null' && clientName !== '') params.append('clientName', clientName);
  if (year && year !== 'null' && year !== '') params.append('year', year);
  params.append('page', page);
  params.append('pageSize', pageSize);
  return http.get(`${API_URL}/foreignTrade/externalClientSatisfaction?${params.toString()}`);
};

export const getExternalClientSatisfactionQuestions = () =>
  http.get(`${API_URL}/foreignTrade/externalClientSatisfaction/questions`);

export const updateExternalClientSatisfactionQuestions = (payload) =>
  http.post(`${API_URL}/foreignTrade/externalClientSatisfaction/questions/update`, payload);

export const checkExternalSurveyExists = (importId) =>
  http.get(`${API_URL}/foreignTrade/externalClientSatisfaction/checkSurvey?importId=${importId}`);

export const checkExternalSurveyByOrderNumber = (orderNumber) =>
  http.get(`${API_URL}/foreignTrade/externalClientSatisfaction/checkSurveyByOrderNumber?orderNumber=${encodeURIComponent(orderNumber)}`);

export const getExternalSurveyOrdersWithUrls = () =>
  http.get(`${API_URL}/foreignTrade/externalClientSatisfaction/ordersWithUrls`);

export const createExternalOrderInformation = (data) =>
  http.post(`${API_URL}/foreignTrade/externalClientSatisfaction/externalOrderInformation`, data);

export const generateExternalSurveyLink = (payload) =>
  http.post(`${API_URL}/foreignTrade/externalClientSatisfaction/generateLink`, payload);

export const getExternalSurveyByLinkId = (surveyOrderId) =>
  http.get(`${API_URL}/foreignTrade/externalClientSatisfaction/international/survey/${surveyOrderId}`);

export const submitExternalSurveyAnswers = (surveyOrderId, data) =>
  http.post(`${API_URL}/foreignTrade/externalClientSatisfaction/international/survey/${surveyOrderId}/answers`, data);

export const getExternalSurveyAnswerById = (answerId) =>
  http.get(`${API_URL}/foreignTrade/externalClientSatisfaction/answer/${answerId}`);

const appendWalletLineIdsParam = (params, lineIds = []) => {
  if (!Array.isArray(lineIds) || lineIds.length === 0) return;
  params.push(`lineIds=${encodeURIComponent(lineIds.join(","))}`);
};

export const getWalletCollectionHistory = (
  year,
  month,
  page = 1,
  pageSize = 10,
  clientId = null,
  invoiceCode = null,
  lineIds = [],
  userId
) => {
  let url = `${API_URL}/walletCollection/history/${year}/${month}/${page}/${pageSize}`;
  const params = [];
  if (clientId) params.push(`clientId=${clientId}`);
  if (invoiceCode) params.push(`invoiceCode=${encodeURIComponent(invoiceCode)}`);
  appendWalletLineIdsParam(params, lineIds);
  params.push(`userId=${encodeURIComponent(userId)}`);
  url += `?${params.join("&")}`;
  return http.get(url);
};

export const getWalletCollectionClients = (userId) =>
  http.get(`${API_URL}/walletCollection/clients`, { params: { userId } });

export const getWalletCollectionInvoices = (year = null, month = null, lineIds = [], userId) => {
  let url = `${API_URL}/walletCollection/invoices`;
  const params = [];
  if (year) params.push(`year=${year}`);
  if (month) params.push(`month=${month}`);
  appendWalletLineIdsParam(params, lineIds);
  params.push(`userId=${encodeURIComponent(userId)}`);
  url += `?${params.join("&")}`;
  return http.get(url);
};

export const uploadWalletCollectionRecaudo = (formData, userId) => {
  formData.append("userId", userId);
  return http.post(`${API_URL}/walletCollection/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteNationalizationTime = (id) =>
  http.post(`${API_URL}/foreignTrade/nationalizationTime/delete/${id}`);

export const walletPreflight = (payload, userId) =>
  http.post(`${API_URL}/wallet/preflight`, { ...payload, userId });

export const downloadWalletCollectionHistory = (
  year,
  month,
  clientId = null,
  invoiceCode = null,
  lineIds = [],
  userId
) => {
  let url = `${API_URL}/walletCollection/download/${year}/${month}`;
  const params = [];
  if (clientId) params.push(`clientId=${clientId}`);
  if (invoiceCode) params.push(`invoiceCode=${encodeURIComponent(invoiceCode)}`);
  appendWalletLineIdsParam(params, lineIds);
  params.push(`userId=${encodeURIComponent(userId)}`);
  url += `?${params.join("&")}`;
  return http.get(url, { responseType: "blob" });
};

export const postUploadAdverseEventFile = (biomedicalEquipmentId, eventId, formData) =>
  http.post(
    `${API_URL}/uploadAdverseEventFile/${biomedicalEquipmentId}/${eventId}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" }
    }
  );

export const downloadBiomedicalEquipmentAdverseEventFile = (adverseEventId) =>
  http.get(
    `${API_URL}/downloadBiomedicalEquipmentAdverseEventFile/${adverseEventId}`,
    {
      responseType: "blob"
    }
  );

export const downloadBiomedicalEquipmentAdverseEventFileByPath = (relativePath) =>
  http.get(buildDownloadUrl(relativePath), {
    responseType: "blob"
  });

export const postPlusInternalLogin = (email, password) =>
  http.post(`${API_URL}/auth/plus/internal`, {
    email,
    password
  });

export const postPlusLegacyLogin = ({ id_usuario, inicio, fin }) =>
  http.post(`${API_URL}/auth/plus/legacy`, {
    id_usuario,
    inicio,
    fin
  });

export const postVerifyPlusEntraToken = (idToken) =>
  http.post(`${API_URL}/auth/plus/entra/verify`, {
    idToken
  });

